<div class="flex flex-col justify-between min-h-screen p-4 container">
    <div class="flex flex-col items-center justify-center">
        <!-- intro -->
        <div class="flex flex-row my-16">
            <img src="/assets/car.svg" class="h-20"/>
            <div class="h-20 w-px bg-black block mx-6"></div>
            <div class="font-medium text-xl leading-tight">Willkommen,<br /><span class="font-normal text-base">registrieren Sie sich,<br />um fortzufahren.</span></div>
        </div>
        <!-- header -->
        <h1 class="text-black text-2xl w-full font-medium">Registrieren</h1>
        <h2 class="text-black w-full mb-4">Erstellen Sie Ihren Account.</h2>
        <!-- register -->
        <div class="flex flex-col w-full">
            <!-- mail -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">E-Mail Adresse <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    [ngClass]="{'border-green-500': validMail === true, 'border-red-500': validMail === false}"
                    type="text"
                    [(ngModel)]="mail"
                    placeholder="mail@beispiel.de"
                    (blur)="validateMail()"
                />
            </div>
            <!-- pass -->
            <div class="flex flex-col relative mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Passwort <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400 pr-8"
                    [ngClass]="{'border-green-500': validPass === true, 'border-red-500': validPass === false}"
                    [type]="passType"
                    [(ngModel)]="pass"
                    placeholder="gHWf/3)K"
                    (blur)="validatePass(); validateConf()"
                />
                <button
                    class="absolute toggle-visabilty focus:outline-none focus:text-gray-700"
                    (click)="toggleVisability()"
                    title="Passwort anzeigen/verbergen"
                >
                    <fa-icon *ngIf="passType == 'password'" [icon]="eye"></fa-icon>
                    <fa-icon *ngIf="passType == 'text'" [icon]="eyeSlash"></fa-icon>
                </button>
            </div>
            <!-- confirm pass -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Passwort bestätigen <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    [ngClass]="{'border-green-500': validConf === true, 'border-red-500': validConf === false}"
                    type="password"
                    [(ngModel)]="passConf"
                    placeholder="gHWf/3)K"
                    (blur)="validateConf()"
                />
            </div>
            <!-- name -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Vor- und Nachname <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    type="text"
                    [(ngModel)]="data.name"
                    placeholder="Max Mustermann"
                />
            </div>
            <!-- phone -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Telefonnummer <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    type="text"
                    [(ngModel)]="data.phone"
                    placeholder="+49 151 1234567"
                />
            </div>
            <!-- zip and city -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Postleitzahl und Stadt <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    type="text"
                    [(ngModel)]="data.zipcity"
                    placeholder="91555 Feuchtwangen"
                />
            </div>
            <!-- street and number -->
            <div class="flex flex-col mb-4">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Strasse und Hausnummer <sup>*</sup></label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    type="text"
                    [(ngModel)]="data.streetnumber"
                    placeholder="Walkmühlweg 18"
                />
            </div>
            <!-- cid -->
            <div class="flex flex-col">
                <label class="uppercase text-gray-700 font-medium text-xs mb-1">Kundennummer</label>
                <input
                    class="appearance-none block border-2 border-gray-300 py-2 px-3 leading-tight focus:outline-none focus:border-primary-500 placeholder-gray-400"
                    type="text"
                    [(ngModel)]="data.cid"
                    placeholder="sk213124"
                />
            </div>
            <!-- info -->
            <div class="flex flex-row justify-between my-4">
                <span class="text-gray-700"><sup>*</sup> Pflichtfelder</span>
            </div>
            <!-- error -->
            <div class="flex flex-row items-center justify-center mb-4 w-full bg-red-600 text-white px-4 py-2" *ngIf="error">
                <fa-icon [icon]="exclamationCircle"></fa-icon>
                <div class="h-4 w-px bg-white block mx-4"></div>
                <div>{{error}}</div>
            </div>
            <button class="btn btn-primary w-full" type="submit" (click)="register($event)">Registrieren <fa-icon [icon]="longArrowRight"></fa-icon></button>
        </div>
        <!-- register link-->
        <span class="text-sm text-center my-4">
            Sie haben bereits einen Account?
            <a class="text-primary-500 hover:text-primary-700 focus:underline focus:outline-none" [routerLink]="['']">
                Anmelden
            </a>
        </span>
    </div>
    <app-legal></app-legal>
</div>
